// Copyright (c) 2016 Deere & Company

import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const updateRegisteredDateRangeFacet = (state, action) =>
    Facets.update(state, {
        registeredDateRange: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateProductSearchDealerFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });
const updateProductSearchDealerFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const setProductStatus = (state, action) =>
    Facets.update(state, {
        statusFacet: {
            allowedStatuses: {$set: action.statusList},
            selectedStatuses: {$set: action.statusList}
        }
    });

const toggleProductSearchDealerFacetItems = (state, action) =>

    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const resetProductSearchFacets = (state, action) =>
    Facets.update(state, {
        $merge: {
            dealerAccountsFacet: {
                ...state.dealerAccountsFacet,
                displayedDealers: action.allowedDealers,
                searchInput: '',
                selectedDealers: action.allowedDealers
            },
            registeredDateRange: getDefaultState().registeredDateRange,
            statusFacet: {
                ...state.statusFacet,
                selectedStatuses: action.allowedStatuses
            }
        }
    });

const updateDealerFacetsOnLoad = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateProductSearchStatusFacetItem = (state, action) =>
    Facets.update(state, {
        statusFacet: {
            selectedStatuses: {
                $set: updateList(
                    action.status,
                    action.isSelected,
                    'key',
                    state.statusFacet.selectedStatuses
                )
            }
        }
    });

const toggleProductSearchStatusFacetItems = (state, action) => {

    const updateSelectedStatuses = state.statusFacet.selectedStatuses.length ?
        [] :
        action.allowedStatuses;

    return Facets.update(state, {
        statusFacet: {
            selectedStatuses: {
                $set: updateSelectedStatuses
            }
        }
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_PRODUCT_SEARCH_FACETS]: resetProductSearchFacets,
        [actions.SET_PRODUCT_SEARCH_STATUS_FACET]: setProductStatus,
        [actions.TOGGLE_PRODUCT_SEARCH_DEALER_FACET_ITEMS]: toggleProductSearchDealerFacetItems,
        [actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_ON_LOAD]: updateDealerFacetsOnLoad,
        [actions.TOGGLE_PRODUCT_SEARCH_STATUS_FACET_ITEMS]: toggleProductSearchStatusFacetItems,
        [actions.UPDATE_REGISTERED_DATE_RANGE_FACET]: updateRegisteredDateRangeFacet,
        [actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_INPUT]: updateProductSearchDealerFacetInput,
        [actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_ITEM]: updateProductSearchDealerFacetItem,
        [actions.UPDATE_PRODUCT_SEARCH_STATUS_FACET_ITEM]: updateProductSearchStatusFacetItem
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/search/reducers/facets.js